import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { FC, useEffect } from 'react';
import FormContainer from '../../Shared/FormContainer/FormContainer';
import { FORM_INFO_COMPONENT_TYPES } from '../types';
import { FormBody, FormInfoWrapper } from './styled';
interface FormInfoCreatedAccountProps {
  type: keyof typeof FORM_INFO_COMPONENT_TYPES;
  formOptions: Record<string, any>;
  onSubmit: (data: Record<string, string>) => void;
  previousPage: Record<string, any>;
}
const FormInfoCreatedAccount: FC<FormInfoCreatedAccountProps> = ({ type, formOptions, onSubmit, previousPage }) => {
  const { t } = useTranslation();
  const title = t(FORM_INFO_COMPONENT_TYPES[type].title);
  const body = t(FORM_INFO_COMPONENT_TYPES[type].body);
  const { handleSubmit, register, setFocus } = formOptions;

  useEffect(() => {
    setFocus('info');
  }, []);

  return (
    <FormInfoWrapper>
      <FormContainer title={title} previousPage={previousPage} onSubmit={handleSubmit(onSubmit)}>
        <input {...register('info')} type="text" style={{ opacity: 0, width: 0, height: 0 }} />
        <FormBody>{body}</FormBody>
      </FormContainer>
    </FormInfoWrapper>
  );
};

export default FormInfoCreatedAccount;
